import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

const tableFooterVariants = tv({
  base: "bg-surface-sunken font-medium text-content",
});

export const TableFooter = ({ className, ...props }: ComponentProps<"tfoot">) => {
  return <tfoot className={tableFooterVariants({ className })} {...props} />;
};
